import { useNavigate } from 'react-router-dom';
import { Lock, Sparkles } from 'lucide-react';

export function ExpiredReadOnlyBanner() {
  const navigate = useNavigate();

  return (
    // mpg-focus-scope: shown above every screen for expired accounts, outside each screen's own scope.
    <div className="mpg-focus-scope fixed inset-x-0 top-0 z-40 px-3 pt-3 md:px-6">
      <div className="mx-auto max-w-[1200px] rounded-[24px] border border-[#D9DECF] bg-[#FFFDF7]/95 px-4 py-3 shadow-[0_10px_30px_rgba(31,40,20,0.12)] backdrop-blur md:px-5">
        <div className="flex items-start gap-3 md:items-center md:justify-between">
          <div className="flex items-start gap-3">
            <div className="mt-0.5 flex h-10 w-10 items-center justify-center rounded-full bg-[#EEF4E6] text-[#58723F] md:mt-0">
              <Lock className="h-4 w-4" aria-hidden="true" />
            </div>
            <div>
              <div className="flex items-center gap-2 text-[14px] font-semibold text-[#1F2814] md:text-[15px]">
                <span>Read-only mode is on</span>
                <span className="inline-flex items-center gap-1 rounded-full bg-[#F3F5EC] px-2 py-0.5 text-[11px] font-medium text-[#5D6B4F]">
                  <Sparkles className="h-3 w-3" aria-hidden="true" />
                  Trial ended
                </span>
              </div>
              <p className="mt-1 text-[13px] leading-5 text-[#5A6252] md:text-[14px]">
                You can browse your meal plans, recipes, and shopping list, but editing is blocked until you reactivate.
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={() => navigate('/plans', { state: { source: 'trial-expired-banner' } })}
            className="ml-13 mt-3 inline-flex min-h-[44px] shrink-0 items-center justify-center rounded-full bg-[#AFBB8B] px-5 py-2 text-sm font-medium text-[#1F2814] transition-colors hover:bg-[#9AA876] md:ml-4 md:mt-0"
          >
            View plans
          </button>
        </div>
      </div>
    </div>
  );
}

export default ExpiredReadOnlyBanner;